import { mutatorAction } from 'satcheljs';
import { type MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from '../selectors/getAsyncItemRegistry';

/**
 * Records the generated title for a single async item, leaving its `prompt` intact so surfaces
 * that show the original request are unaffected. No-op if the item is untracked.
 */
export const setAsyncItemTitleMutator: (
    mailboxInfo: MailboxInfo,
    id: string,
    title: string
) => void = mutatorAction('setAsyncItemTitleMutator', (mailboxInfo, id, title) => {
    const entry = getAsyncItemRegistry(mailboxInfo)?.entriesById.get(id);
    if (entry) {
        entry.title = title;
    }
});
